var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReversal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.245,
    height: 13.412,
    viewBox: "0 0 16.245 13.412",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18857",
    "data-name": "Path 18857",
    d: "M13.98,11.117H11.943a.662.662,0,0,1,0-1.324H13.98a.646.646,0,0,0,.646-.646V1.961a.646.646,0,0,0-.646-.646H1.965a.646.646,0,0,0-.646.646V9.15a.646.646,0,0,0,.646.646H6.378l-.823-.823a.662.662,0,0,1,0-.933.662.662,0,0,1,.934,0L8.438,9.989a.658.658,0,0,1,0,.931L6.493,12.87a.66.66,0,0,1-.933-.933l.823-.823H1.965A1.966,1.966,0,0,1,0,9.15V1.965A1.966,1.966,0,0,1,1.965,0H13.98a1.966,1.966,0,0,1,1.965,1.965V9.15A1.968,1.968,0,0,1,13.98,11.117Z",
    transform: "translate(16.095 13.262) rotate(180)",
    fill: "#585858",
    stroke: "#585858",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReversal);
export default __webpack_public_path__ + "static/media/reversal.14c4a820bd948d7fbb2c3dddcf0875e0.svg";
export { ForwardRef as ReactComponent };